export default {
  translation: {
    // Common
    "app.name": "Give Protocol",
    "app.tagline": "透明、無國界的慷慨基礎設施。",
    "common.skipToMainContent": "跳到主要內容",
    "common.cancel": "取消",
    "common.edit": "編輯",
    "common.delete": "刪除",
    "common.creating": "建立中...",
    "common.unknown": "未知",
    "common.notAvailable": "不適用",

    // Navigation
    "nav.browse": "瀏覽慈善機構",
    "nav.opportunities": "志工機會",
    "nav.contributions": "貢獻追蹤",
    "nav.governance": "治理",
    "nav.dashboard": "Give 儀表板",
    "nav.about": "關於",
    "nav.docs": "文件",
    "nav.legal": "法律",
    "nav.launchApp": "啟動應用程式",

    // FAQ page (GIV-988)
    "faq.title": "常見問題",
    "faq.subtitle": "關於捐贈、志願服務和區塊鏈透明度，您需要了解的一切。",

    // Settings
    "settings.title": "設定",
    "settings.language": "語言",
    "settings.currency": "幣別",

    // Auth
    "auth.login": "登入",
    "auth.register": "建立帳號",
    "auth.logout": "登出",
    "auth.forgotPassword": "忘記密碼？",

    // Dashboard
    "dashboard.title": "Give 儀表板",
    "dashboard.subtitle": "追蹤您的捐款與志工貢獻",
    "dashboard.totalDonations": "捐款總額",
    "dashboard.volunteerHours": "志工時數",
    "dashboard.skillsEndorsed": "已認可技能",
    "dashboard.contributions": "貢獻",
    "dashboard.yourTotalDonated": "您的捐款總額",
    "dashboard.yourVolunteerHours": "您的志工時數",
    "dashboard.yourSkillsEndorsed": "您獲認可的技能",
    "dashboard.impactGrowth": "影響力成長",
    "dashboard.charitiesSupported": "支持的慈善機構",

    // Charity
    "charity.dashboard": "慈善機構儀表板",
    "charity.subtitle": "管理您的捐款與志工計畫",
    "charity.activeVolunteers": "活躍志工",
    "charity.transactions": "交易紀錄",
    "charity.volunteers": "志工時數",
    "charity.applications": "申請",
    "charity.totalReceived": "累計收到",
    "charity.equityPoolValue": "公平池價值",
    "charity.availableBalance": "可用餘額",

    // Contributions
    "contributions.date": "日期",
    "contributions.type": "類型",
    "contributions.organization": "組織",
    "contributions.details": "詳情",
    "contributions.status": "狀態",
    "contributions.verification": "驗證",
    "contributions.export": "匯出 CSV",

    // Volunteer
    "volunteer.opportunities": "志工機會",
    "volunteer.searchOpportunities": "搜尋機會...",
    "volunteer.selectSkill": "選擇技能",
    "volunteer.selectType": "選擇類型",
    "volunteer.selectLanguage": "選擇語言",
    "volunteer.allSkills": "所有技能",
    "volunteer.allTypes": "所有類型",
    "volunteer.allLanguages": "所有語言",
    "volunteer.applyNow": "立即申請",
    "volunteer.noOpportunitiesFound": "未找到符合條件的機會。",
    "volunteer.verify": "驗證時數",
    "volunteer.verifying": "驗證中...",
    "volunteer.reject": "拒絕",
    "volunteer.accept": "接受",
    "volunteer.processing": "處理中...",
    "volunteer.hours": "小時於",
    "volunteer.description": "說明",
    "volunteer.appliedFor": "已申請",
    "volunteer.verificationComplete": "驗證完成",
    "volunteer.hoursVerified": "志工時數已驗證並記錄在區塊鏈上。",
    "volunteer.verificationHash": "驗證雜湊值",
    "volunteer.applicationAccepted": "申請已接受",
    "volunteer.applicationRecorded": "志工申請已被接受並記錄在區塊鏈上。",
    "volunteer.acceptanceHash": "接受雜湊值",
    "volunteer.pendingHours": "待驗證志工時數",
    "volunteer.noPendingHours": "沒有待驗證的志工時數。",
    "volunteer.pendingApplications": "待審核申請",
    "volunteer.noPendingApplications": "沒有待審核的申請。",
    "volunteer.createOpportunity": "建立志工機會",
    "volunteer.createNew": "建立新機會",
    "volunteer.noOpportunitiesYet":
      "尚未建立任何機會。點擊「建立新機會」開始。",
    "volunteer.opportunityTitle": "機會標題",
    "volunteer.skills": "技能（以逗號分隔）",
    "volunteer.commitment": "承諾",
    "volunteer.location": "地點",
    "volunteer.type": "類型",
    "volunteer.workLanguage": "工作語言",
    "volunteer.status": "狀態",

    // Volunteer commitment types
    "volunteer.commitment.oneTime": "一次性",
    "volunteer.commitment.shortTerm": "短期",
    "volunteer.commitment.longTerm": "長期",

    // Volunteer types
    "volunteer.type.remote": "遠端",
    "volunteer.type.onsite": "現場",
    "volunteer.type.hybrid": "混合",
    "volunteer.type.onSite": "現場",

    // Volunteer - Opportunities page
    "volunteer.workTypeFilter": "工作類型篩選",
    "volunteer.searchLocation": "城市或地區...",
    "volunteer.searchLocationAria": "搜尋地點",
    "volunteer.filter.skill": "技能：{{value}}",
    "volunteer.filter.type": "類型：{{value}}",
    "volunteer.filter.language": "語言：{{value}}",
    "volunteer.filter.location": "地點：{{value}}",
    "volunteer.loadingOpportunities": "正在載入機會...",
    "volunteer.loadOpportunitiesError": "無法載入志工機會，請稍後再試。",
    "volunteer.viewDetails": "查看詳情",
    "volunteer.backToOpportunities": "返回機會列表",
    "volunteer.detail.about": "關於此機會",
    "volunteer.detail.skills": "所需技能",
    "volunteer.detail.commitment": "時間投入",
    "volunteer.detail.location": "地點",
    "volunteer.detail.language": "語言",
    "volunteer.detail.hostedBy": "主辦單位",
    "volunteer.detail.ongoing": "長期進行",
    "volunteer.detail.applicationsClosed": "申請已截止",
    "volunteer.detail.notFoundTitle": "找不到該機會",
    "volunteer.detail.notFoundMessage": "該機會可能已額滿或已被移除。",
    "volunteer.field.requirements": "要求",
    "volunteer.field.benefits": "福利",
    "volunteer.field.schedule": "時間安排",
    "volunteer.field.schedulePlaceholder": "例如：週二 18:00-20:00，週末彈性",
    "volunteer.field.startDate": "開始日期",
    "volunteer.field.endDate": "結束日期",
    "volunteer.field.endDateHelp": "如長期進行請留空",
    "volunteer.field.applicationDeadline": "申請截止日期",
    "volunteer.field.volunteersNeeded": "所需志工人數",
    "volunteer.field.minimumAge": "最低年齡",
    "volunteer.field.backgroundCheckRequired": "需要背景審查",
    "volunteer.field.trainingProvided": "提供培訓",
    "volunteer.field.onePerLine": "每行一項",
    "volunteer.validation.volunteersNeeded": "請輸入大於或等於 1 的數字",
    "volunteer.validation.minimumAge": "請輸入 0 到 120 之間的年齡",
    "volunteer.validation.endDate": "結束日期不得早於開始日期",
    "volunteer.signInToApply": "請登入後申請志工機會",
    "volunteer.applicationSuccess": "申請提交成功！",
    "volunteer.removeFilter": "移除 {{filter}} 篩選",

    // Volunteer - OpportunityForm
    "volunteer.validation.titleRequired": "標題為必填",
    "volunteer.validation.descriptionRequired": "說明為必填",
    "volunteer.validation.skillsRequired": "至少需要一項技能",
    "volunteer.validation.locationRequired": "地點為必填",
    "volunteer.profileNotFound": "未找到使用者資料",
    "volunteer.correctErrors": "請更正驗證錯誤",
    "volunteer.createFailed": "建立機會失敗",
    "volunteer.descriptionPlaceholder": "詳細描述此志工機會...",
    "volunteer.skillsPlaceholder": "例如：網頁開發、專案管理、翻譯",
    "volunteer.locationPlaceholder": "例如：遠端、台北、高雄",
    "volunteer.headerImage": "封面圖片",
    "volunteer.headerImageHelp": "上傳一張圖片顯示在您的機會列表頂部",
    "volunteer.limitReached": "機會數量已達上限",
    "volunteer.limitReachedMessage":
      "您已達到最多 {{max}} 個活躍志工機會的上限。請關閉或完成一個現有機會後再建立新機會。",
    "volunteer.opportunityCount": "您有 {{count}} / {{max}} 個活躍機會。",

    // Volunteer - HoursVerificationTab
    "volunteer.hoursVerification": "時數驗證",
    "volunteer.hoursVerificationDescription": "審核和驗證志工時數提交",
    "volunteer.formalHours": "已記錄時數",
    "volunteer.selfReported": "自行回報",
    "volunteer.loggedHours": "已記錄志工時數",
    "volunteer.loggedHoursDescription": "志工透過您的機會記錄的時數",
    "volunteer.allCaughtUp": "全部處理完畢！",
    "volunteer.noPendingLoggedHours": "沒有待驗證的已記錄時數。",
    "volunteer.selfReportedHours": "自行回報時數",

    // Volunteer - OpportunitiesTab
    "volunteer.noOpportunitiesTitle": "尚無機會",
    "volunteer.activeCount": "{{count}} / {{max}} 個活躍機會",
    "volunteer.moreSkills": "+{{count}} 更多",

    // Volunteer - ApplicationsTab
    "volunteer.noApplications": "沒有待審核的申請",
    "volunteer.unknownOpportunity": "未知機會",

    // Volunteer - VerificationLookup
    "volunteer.verifyContribution": "驗證志工貢獻",
    "volunteer.hashPlaceholder": "輸入驗證雜湊值",
    "volunteer.searching": "搜尋中...",
    "volunteer.verifyHash": "驗證雜湊值",
    "volunteer.verificationNotFound": "未找到驗證紀錄",
    "volunteer.verificationNotFoundMessage":
      "您提供的雜湊值未在我們的紀錄中找到。請檢查雜湊值後重試。",
    "volunteer.unknownOrganization": "未知組織",

    // Volunteer - VolunteerVerificationCard
    "volunteer.contributionVerification": "志工貢獻驗證",
    "volunteer.volunteerLabel": "志工",
    "volunteer.opportunityLabel": "機會",
    "volunteer.organizationLabel": "組織",
    "volunteer.acceptedOn": "接受日期",
    "volunteer.verifiedOn": "驗證日期",
    "volunteer.verificationHashes": "驗證雜湊值",
    "volunteer.blockchainReference": "區塊鏈參考",

    // Volunteer - VerifyContribution page
    "volunteer.verifyingContribution": "正在驗證貢獻\u2026",
    "volunteer.noHashProvided": "未提供驗證雜湊值。",
    "volunteer.verificationSuccessful": "驗證成功",
    "volunteer.contributionVerifiedBlockchain":
      "此志工貢獻已驗證並記錄在區塊鏈上。",
    "volunteer.verificationFailed": "驗證失敗",
    "volunteer.hashNotFound": "驗證雜湊值 {{hash}} 未找到或無效。",

    // Volunteer - SelfReportedHoursDashboard
    "volunteer.volunteerHoursTitle": "志工時數",
    "volunteer.aboutSelfReported": "關於自行回報時數",
    "volunteer.selfReportedInfo":
      "只有經認證組織驗證的時數才計入全球影響力排名。未在平台註冊的組織的時數可以記錄，但在獲得驗證前將標記為「未驗證」。",
    "volunteer.logHoursButton": "記錄時數",
    "volunteer.logVolunteerHours": "記錄志工時數",
    "volunteer.editRecord": "編輯紀錄",
    "volunteer.recordDetails": "紀錄詳情",
    "volunteer.backToList": "返回列表",
    "volunteer.deleteRecord": "刪除紀錄？",
    "volunteer.deleteConfirmation":
      "確定要刪除此志工時數紀錄嗎？此操作無法復原。",

    // Volunteer - SelfReportedHoursForm
    "volunteer.activityType": "活動類型",
    "volunteer.organization": "組織",
    "volunteer.searchRegistry": "搜尋登記資料",
    "volunteer.searchRegistryPlaceholder": "依名稱或稅務編號搜尋慈善機構登記…",
    "volunteer.registryTaxId": "稅務編號 {{value}}",
    "volunteer.notListed": "未列出",
    "volunteer.organizationName": "組織名稱",
    "volunteer.enterOrgName": "輸入組織名稱",
    "volunteer.contactEmail": "聯絡電子郵件",
    "volunteer.contactEmailOptional": "（選填）",
    "volunteer.onboardHelp": "我們可能會聯繫以協助該組織加入平台",
    "volunteer.submittedForValidation": "此紀錄將提交驗證",
    "volunteer.submittedForValidationTo": "此紀錄將提交給 {{org}} 進行驗證",
    "volunteer.validationExpired": "此日期的驗證期限已過",
    "volunteer.savedAsUnvalidated": "此紀錄將儲存為未驗證",
    "volunteer.describeActivities": "描述您執行的活動...",
    "volunteer.moreCharsNeeded": "還需 {{count}} 個字元",
    "volunteer.updating": "更新中...",
    "volunteer.logging": "記錄中...",
    "volunteer.updateHours": "更新時數",

    // Volunteer - SelfReportedHoursList
    "volunteer.statusFilter": "狀態",
    "volunteer.activityTypeFilter": "活動類型",
    "volunteer.filterFrom": "從",
    "volunteer.filterTo": "到",
    "volunteer.clearFilters": "清除篩選",
    "volunteer.allStatuses": "全部",
    "volunteer.allActivityTypes": "所有類型",
    "volunteer.noMatchingRecords": "沒有符合的紀錄",
    "volunteer.noHoursLogged": "尚未記錄任何志工時數",
    "volunteer.adjustFilters": "嘗試調整篩選條件來查找紀錄。",
    "volunteer.startLogging": "開始記錄您的第一次志工時數。",

    // Volunteer - SelfReportedHoursStats
    "volunteer.validatedHours": "已驗證時數",
    "volunteer.pendingValidation": "待驗證",
    "volunteer.unvalidatedHours": "未驗證時數",
    "volunteer.rejectedLabel": "已拒絕",
    "volunteer.hoursUnit": "小時",
    "volunteer.recordSingular": "筆紀錄",
    "volunteer.recordPlural": "筆紀錄",

    // Volunteer - VolunteerApplicationForm
    "volunteer.applicationTitle": "志工機會申請",
    "volunteer.applicationSubtitle": "透過經驗證的貢獻幫助創造永續的影響",
    "volunteer.progress.info": "資訊",
    "volunteer.progress.skills": "技能",
    "volunteer.progress.consent": "同意",
    "volunteer.fieldValid": "看起來不錯",
    "volunteer.draftSaved": "草稿已儲存",
    "volunteer.personalInfo": "個人資訊",
    "volunteer.firstName": "名",
    "volunteer.lastName": "姓",
    "volunteer.emailAddress": "電子郵件地址",
    "volunteer.phoneNumber": "電話號碼",
    "volunteer.locationCity": "所在城市",
    "volunteer.locationCityPlaceholder": "例如：台北市",
    "volunteer.timeZone": "時區",
    "volunteer.selectTimeZone": "選擇時區",
    "volunteer.ageRange": "年齡範圍",
    "volunteer.selectAgeRange": "選擇年齡範圍",
    "volunteer.skillsAndInterests": "技能與興趣",
    "volunteer.skillsLabel": "技能和興趣領域",
    "volunteer.skillPlaceholderFull":
      "輸入您的技能（例如：Python 程式設計、公開演講、提案撰寫）",
    "volunteer.skillPlaceholderShort": "輸入技能並按 Enter...",
    "volunteer.commitmentLevel": "承諾等級",
    "volunteer.commitmentOneTimeDesc": "單次專案或短期任務",
    "volunteer.commitmentShortTermDesc": "數週到數月",
    "volunteer.commitmentLongTermDesc": "持續數月或更長時間的承諾",
    "volunteer.experienceLabel": "請介紹您的相關經驗",
    "volunteer.experiencePlaceholder":
      "描述您的背景、技能以及您參與 Give Protocol 志工服務的動機...",
    "volunteer.consentTitle": "同意與協議",
    "volunteer.consentHeader": "志工申請同意書",
    "volunteer.submitting": "提交中...",
    "volunteer.submitApplication": "提交志工申請",
    "volunteer.disclaimerText":
      "提交此申請即表示您已閱讀並理解 Give Protocol 的隱私政策和志工指南。您的資料將根據適用的資料保護法規進行處理。",
    "volunteer.validation.firstNameInvalid": "請輸入有效的名",
    "volunteer.validation.lastNameInvalid": "請輸入有效的姓",
    "volunteer.validation.emailInvalid": "請輸入有效的電子郵件地址",
    "volunteer.validation.phoneInvalid": "請輸入有效的電話號碼",
    "volunteer.validation.experienceRequired": "請描述您的相關經驗",
    "volunteer.validation.addSkill": "請新增至少一項技能",
    "volunteer.validation.ageRangeRequired": "請選擇您的年齡範圍",
    "volunteer.validation.consentRequired": "您必須同意所有必要的同意項目",
    "volunteer.signInToSubmit": "請登入後提交申請",
    "volunteer.submitFailed": "提交申請失敗，請重試。",

    // Volunteer - ApplicationForm
    "volunteer.applyForTitle": "申請：{{title}}",
    "volunteer.fullName": "全名 *",
    "volunteer.phoneRequired": "電話號碼 *",
    "volunteer.emailRequired": "電子郵件 *",
    "volunteer.dateOfBirth": "出生日期",
    "volunteer.availabilityTitle": "可用時間",
    "volunteer.preferredDays": "偏好日期",
    "volunteer.preferredTimes": "偏好時段",
    "volunteer.commitmentLevelLabel": "承諾等級",
    "volunteer.skillsAndExperience": "技能與經驗",
    "volunteer.relevantExperience": "相關經驗 *",
    "volunteer.certifications": "證照（以逗號分隔）",
    "volunteer.interestsAndPreferences": "興趣與偏好",
    "volunteer.areasOfInterest": "興趣領域（以逗號分隔）",
    "volunteer.referencesTitle": "推薦人",
    "volunteer.referenceName": "推薦人 {{index}} 姓名",
    "volunteer.referenceContact": "推薦人 {{index}} 聯絡方式",
    "volunteer.workSamplesTitle": "作品範例",
    "volunteer.workSamplesLabel": "作品範例連結（以逗號分隔）",
    "volunteer.submitApplicationShort": "提交申請",
    "volunteer.validation.nameInvalid": "請輸入有效的姓名（2-100 個字元）",
    "volunteer.validation.provideExperience": "請提供您的經驗資訊",
    "volunteer.validation.selectDay": "請至少選擇一天",
    "volunteer.validation.selectTime": "請至少選擇一個時段",

    // Volunteer - ConsentForm
    "volunteer.consentUnderstand": "我瞭解：",
    "volunteer.processingAckTitle": "處理確認",
    "volunteer.processingAckDesc": "請在繼續之前查閱並確認以下內容：",
    "volunteer.essentialProcessingTitle": "申請處理（需要確認）：",
    "volunteer.acknowledgmentTitle": "確認",
    "volunteer.ageConfirmationTitle": "年齡確認：",
    "volunteer.privacyNoticeTitle": "隱私聲明：",
    "volunteer.doNotAccept": "不接受",
    "volunteer.acceptAndContinue": "接受並繼續",
    "volunteer.validation.essentialRequired": "您必須確認申請處理確認才能繼續",
    "volunteer.validation.agePrivacyRequired": "您必須確認年齡並已閱讀隱私聲明",

    // Age affirmation gate (shared across all surfaces — GIV-453)
    "ageGate.positive": "我確認我已年滿16歲。",
    "ageGate.negative":
      "Give Protocol僅供16歲及以上的使用者使用。如果您未滿16歲，我們目前無法處理您的請求。",

    // Languages
    "language.english": "英語",
    "language.spanish": "西班牙語",
    "language.german": "德語",
    "language.french": "法語",
    "language.japanese": "日語",
    "language.chinese_simplified": "簡體中文",
    "language.chinese_traditional": "繁體中文",
    "language.thai": "泰語",
    "language.vietnamese": "越南語",
    "language.korean": "韓語",
    "language.arabic": "阿拉伯語",
    "language.hindi": "印地語",
    "language.multiple": "多種語言",

    // Contribution types
    "contribution.type.donation": "捐款",
    "contribution.type.volunteerapplication": "志工申請",
    "contribution.type.volunteerhours": "志工時數",
    "contribution.type.volunteeracceptance": "志工接受",
    "contribution.type.volunteerverification": "志工驗證",

    // Donor/Volunteer
    "donor.volunteer": "捐款者/志工",
    "donor.anonymous": "匿名",
    "volunteer.unknown": "未知志工",

    // Statuses
    "status.completed": "已完成",
    "status.pending": "待處理",
    "status.failed": "失敗",

    // Blockchain
    "blockchain.block": "區塊",

    // Filter
    "filter.allYears": "所有年度",
    "filter.allTypes": "所有類型",
    "filter.donations": "捐款",
    "filter.volunteerApplications": "志工申請",
    "filter.volunteerHours": "志工時數",
    "filter.fiatDonations": "法幣捐款",

    // Export
    "export.title": "匯出貢獻資料",
    "export.filename": "檔案名稱",
    "export.dateRange": "日期範圍",
    "export.includePersonal": "包含錢包地址",
    "export.willInclude": "匯出將包含：",
    "export.walletAddresses": "錢包地址（發送方和接收方）",
    "export.volunteerDetails": "志工貢獻詳情（如適用）",
    "export.verificationHashes": "驗證雜湊值（如適用）",
    "export.cancel": "取消",
    "export.download": "匯出 CSV",

    // Skills
    "skills.endorsements": "技能與認可",

    // Home
    "home.subtitle": "將資源連結到最需要的事業",
    "home.startDonating": "開始捐款",

    // Modal - shared
    "modal.close": "關閉視窗",
    "modal.closeAriaLabel": "關閉",

    // Modal - wallet connection
    "modal.wallet.title": "連接您的錢包",
    "modal.wallet.description": "連接錢包以解鎖 Give Protocol 的全部功能",
    "modal.wallet.benefit1": "在區塊鏈上透明地追蹤您的捐款",
    "modal.wallet.benefit2": "透過貢獻獲得 GIVE 代幣獎勵",
    "modal.wallet.benefit3": "參與協議治理決策",
    "modal.wallet.connecting": "連接中...",
    "modal.wallet.clickToConnect": "點擊連接",
    "modal.wallet.noExtension": "未偵測到錢包擴充功能。",
    "modal.wallet.installMetaMask": "安裝 MetaMask 以開始使用",
    "modal.wallet.skip": "暫時跳過",
    "modal.wallet.footerNote": "您可以隨時從導覽列連接錢包",
    "modal.wallet.failedConnect": "連接錢包失敗",

    // Modal - wallet link
    "modal.walletLink.title": "連結您的錢包",
    "modal.walletLink.description":
      "將錢包連結到您的帳號以進行鏈上捐款、獲取代幣獎勵和參與治理",
    "modal.walletLink.benefit1": "直接向鏈上已驗證的慈善機構捐贈加密貨幣",
    "modal.walletLink.benefit2Pre": "累積",
    "modal.walletLink.benefit2Post": "您的貢獻憑證",
    "modal.walletLink.benefit3": "使用電子郵件或錢包登入 \u2014 同一帳號",
    "modal.walletLink.buttonLinking": "連結中\u2026",
    "modal.walletLink.buttonLink": "連結錢包",
    "modal.walletLink.buttonConnectFirst": "先連接錢包",
    "modal.walletLink.footerNote": "您可以隨時從設定中連結錢包",
    "modal.walletLink.failedLink": "連結錢包失敗",

    // Modal - chain selection
    "modal.chain.title": "歡迎來到 Give Protocol",
    "modal.chain.subtitle": "選擇您偏好的網路以開始使用",
    "modal.chain.footerNote": "您可以隨時從選單切換網路",
    "modal.chain.connecting": "連接中...",
    "modal.chain.continue": "繼續",
    "modal.chain.failedSelect": "選擇網路失敗",

    // Modal - network selection (WalletModal step 1)
    "modal.network.title": "選擇網路",
    "modal.network.nextStep": "下一步：連接錢包",
    "modal.network.learnMore": "了解更多關於網路選擇的資訊",

    // Modal - wallet connect (WalletModal step 2)
    "modal.connect.title": "連接錢包",
    "modal.connect.backAria": "返回網路選擇",
    "modal.connect.noWallets": "沒有可用於 {{chainType}} 鏈的錢包。",
    "modal.connect.tryDifferentChain": "嘗試選擇不同的鏈類型。",
    "modal.connect.viewOtherWallets": "檢視其他支援的錢包",
    "modal.connect.termsAgreement": "連接即表示您同意我們的",
    "modal.connect.termsLink": "服務條款",
    "modal.connect.termsPrivacyConnector": "和",
    "modal.connect.privacyLink": "隱私政策",
    "modal.connect.chainTypeAria": "鏈類型",
    "modal.connect.failedConnect": "連接失敗",

    // Modal - donation
    "modal.donation.successTitle": "謝謝您！",
    "modal.donation.donationProcessedOneTime":
      "您向 {{charityName}} 捐款的 {{amount}} 已處理完成。",
    "modal.donation.donationProcessedRecurring":
      "您向 {{charityName}} 的每月 {{amount}} 捐款已處理完成。",
    "modal.donation.recurringNote": "將每月扣款直到您取消。",
    "modal.donation.receiptNote": "收據已寄送至您的電子郵件。",
    "modal.donation.done": "完成",
    "modal.donation.errorTitle": "發生問題",
    "modal.donation.errorDefault": "發生意外錯誤，請重試。",
    "modal.donation.tryAgain": "重試",
    "modal.donation.close": "關閉",
    "modal.donation.amountLabel": "捐款金額",
    "modal.donation.perMonth": "每月",
    "modal.donation.monthly": "按月",
    "modal.donation.oneTime": "一次性",
    "modal.donation.loadingPaymentForm": "正在載入付款表單...",
    "modal.donation.supportMonthly": "每月支持 {{charityName}}",
    "modal.donation.donateToCharity": "捐款給 {{charityName}}",

    // Modal - scheduled donation
    "modal.scheduledDonation.title": "設定每月向 {{charityName}} 的定期捐款",

    // Modal - withdrawal
    "modal.withdrawal.title": "申請提款",

    // Modal - validation response
    "modal.validation.rejectTitle": "拒絕驗證請求",
    "modal.validation.reviewTitle": "審核驗證請求",
    "modal.validation.volunteer": "志工",
    "modal.validation.activityDetails": "活動詳情",
    "modal.validation.date": "日期",
    "modal.validation.hour": "小時",
    "modal.validation.hours": "小時",
    "modal.validation.activityType": "活動類型",
    "modal.validation.location": "地點",
    "modal.validation.description": "說明",
    "modal.validation.submitted": "提交時間：",
    "modal.validation.daysRemaining": "（剩餘 {{count}} 天可驗證）",
    "modal.validation.appealNote": "這是先前被拒絕請求的申訴/重新提交",
    "modal.validation.rejectPrompt":
      "請選擇拒絕此驗證請求的原因。志工將收到通知。",
    "modal.validation.reject": "拒絕",
    "modal.validation.approve": "核准",
    "modal.validation.processing": "處理中...",
    "modal.validation.back": "返回",
    "modal.validation.confirmRejection": "確認拒絕",
    "modal.validation.selectReasonError": "請選擇拒絕原因",

    // Toast
    "toast.dismiss": "關閉通知",

    // Error boundary
    "error.somethingWrong": "發生問題",
    "error.unexpectedError": "發生意外錯誤",
    "error.tryAgain": "重試",
    "error.tooManyAttempts": "嘗試次數過多",
    "error.goHome": "返回首頁",
    "error.details": "錯誤詳情",

    // Validation - rejection reason select
    "validation.rejection.reasonLabel": "拒絕原因",
    "validation.rejection.reasonPlaceholder": "選擇原因...",
    "validation.rejection.notesLabel": "附加說明",
    "validation.rejection.optional": "（選填）",
    "validation.rejection.notesPlaceholder": "提供拒絕的額外說明...",

    // Validation - batch actions
    "validation.batch.deselectAll": "取消全選",
    "validation.batch.selectAll": "全選",
    "validation.batch.selected": "已選 {{selected}} / {{total}}",
    "validation.batch.clear": "清除",
    "validation.batch.reject": "拒絕 ({{count}})",
    "validation.batch.approve": "核准 ({{count}})",

    // Dashboard - admin redirect (GIV-254)
    "dashboard.adminTitle": "管理儀表板",
    "dashboard.adminNote": "請使用管理面板來管理平台。",
    "dashboard.adminButton": "前往管理面板",
    "dashboard.logVolunteerHours": "記錄志工時數",
    "dashboard.hideVolunteerHours": "隱藏志工時數",
    "dashboard.viewMonthlyDonations": "檢視每月捐款",
    "dashboard.hideMonthlyDonations": "隱藏每月捐款",
    "dashboard.walletSettings": "錢包設定",
    "dashboard.overview": "總覽",
    "dashboard.lastUpdated": "最後更新",
    "dashboard.refreshData": "重新整理資料",
    "dashboard.searchPlaceholder": "搜尋專案、志工 (Cmd+K)",
    "dashboard.search": "搜尋",

    // Settings - account section (GIV-254)
    "settings.manageDescription": "管理您的帳號和偏好設定",
    "settings.account": "帳號",
    "settings.email": "電子郵件",
    "settings.displayName": "顯示名稱",
    "settings.authMethod": "驗證方式",
    "settings.role": "角色",

    // Common additional (GIV-254)
    "common.refresh": "重新整理",
    "common.all": "全部",
    "common.loading": "載入中...",
    "common.close": "關閉",
    "common.back": "返回",

    // Cause (GIV-254)
    "cause.createCause": "建立公益事業",

    // Contribution Tracker (GIV-254)
    "tracker.title": "全球影響力排名",
    "tracker.subtitle": "追蹤與表揚我們社群的集體影響",
    "tracker.searchPlaceholder": "搜尋貢獻者...",
    "tracker.exportCSV": "匯出 CSV",
    "tracker.exportPDF": "匯出 PDF",
    "tracker.hideContributions": "從排名中隱藏我的貢獻",
    "tracker.yourAlias": "您的別名：",
    "tracker.changeAlias": "變更",
    "tracker.setWalletAlias": "設定錢包別名",
    "tracker.aliasTitle": "設定錢包別名",
    "tracker.aliasDescription":
      "您的別名將在貢獻追蹤中顯示，取代您的錢包地址。",
    "tracker.aliasLabel": "別名",
    "tracker.aliasPlaceholder": "輸入您偏好的別名",
    "tracker.saveAlias": "儲存別名",
    "tracker.donationRankings": "捐款排名",
    "tracker.volunteerRankings": "志工排名",
    "tracker.exportComplete": "匯出完成",
    "tracker.exportDonationCSV": "捐款排行榜已匯出為 CSV",
    "tracker.exportVolunteerCSV": "志工排行榜已匯出為 CSV",
    "tracker.exportPDFSuccess": "排行榜已匯出為 PDF",
    "tracker.exportFailed": "匯出失敗",
    "tracker.exportNoData": "沒有可匯出的資料",
    "tracker.exportError": "匯出資料時發生錯誤",
    "tracker.walletNotConnected": "錢包未連接",
    "tracker.connectWalletForAlias": "請連接錢包以設定別名",
    "tracker.invalidAlias": "別名無效",
    "tracker.enterValidAlias": "請輸入有效的別名",

    // Charity Portal (GIV-254)
    "charity.portal.deleteTitle": "刪除{{type}}？",
    "charity.portal.deleteDescription":
      "此操作無法復原。{{type}}將被永久刪除。",
    "charity.portal.walletNotConfigured": "未設定接收錢包。",
    "charity.portal.walletDonationNote": "連接錢包以接收鏈上捐款。",
    "charity.portal.setupWallet": "設定錢包",

    // Charity dashboard onboarding & verification
    "charity.onboarding.ariaLabel": "入駐清單",
    "charity.onboarding.title": "開始使用",
    "charity.onboarding.progress": "已完成 {{completed}}/{{total}} 個步驟",
    "charity.onboarding.optional": "選填",
    "charity.onboarding.allComplete": "所有步驟皆已完成！您可以關閉此清單。",
    "charity.onboarding.expand": "展開清單",
    "charity.onboarding.collapse": "收合清單",
    "charity.onboarding.dismiss": "關閉入駐清單",
    "charity.onboarding.check": "勾選{{label}}",
    "charity.onboarding.uncheck": "取消勾選{{label}}",
    "charity.onboarding.stepDone": "{{label}}（已完成）",
    "charity.onboarding.stepAuto": "{{label}}（自動完成）",
    "charity.onboarding.goToOrganization": "前往組織",
    "charity.onboarding.setupWallet": "設定錢包",
    "charity.onboarding.item.completeProfile.label": "完善組織資料",
    "charity.onboarding.item.completeProfile.description":
      "新增您的組織名稱、簡介、地址與聯絡資訊。",
    "charity.onboarding.item.uploadLogo.label": "上傳標誌或橫幅圖片",
    "charity.onboarding.item.uploadLogo.description":
      "新增標誌或橫幅，協助捐款者辨識您的慈善機構。",
    "charity.onboarding.item.connectWallet.label": "設定收款錢包",
    "charity.onboarding.item.connectWallet.description":
      "選擇多重簽章 Safe、機構託管或單一簽署者錢包來接收捐款，並透過簽署訊息證明您的控制權。",
    "charity.onboarding.item.bankDetails.label": "設定法幣提領的銀行資訊",
    "charity.onboarding.item.bankDetails.description":
      "若要接受信用卡捐款，請設定銀行資訊。",
    "charity.onboarding.item.acceptTerms.label": "檢視並接受服務條款",
    "charity.onboarding.item.acceptTerms.description":
      "閱讀並確認 Give Protocol 慈善機構條款與條件。",
    "charity.verification.pendingTitle": "申請審核中",
    "charity.verification.pendingBody":
      "我們的團隊正在審核您的慈善機構申請，通常需要 3–5 個工作天。作出決定後我們會以電子郵件通知您。",
    "charity.verification.rejectedTitle": "申請未獲核准",
    "charity.verification.reason": "原因：{{notes}}",
    "charity.verification.rejectedDefault": "您的申請目前未獲核准。",
    "charity.verification.contactSupport": "聯絡支援",
    "charity.verification.suspendedTitle": "帳戶已被停權",
    "charity.verification.suspendedDefault": "您的慈善機構帳戶已被停權。",
    "charity.verification.appealSuspension": "申訴停權",
    "charity.verification.verifiedTitle": "慈善機構已驗證",
    "charity.verification.verifiedBody":
      "您的組織已通過驗證，捐款者現在可以支持您的專案。",
    "charity.portal.receivingWallet": "收款錢包：{{address}}",
    "charity.portal.loadError": "無法載入慈善機構資料，請再試一次。",

    // Timestamps (GIV-254)
    "timestamp.justNow": "剛剛",
    "timestamp.oneMinuteAgo": "1 分鐘前",
    "timestamp.minutesAgo": "{{count}} 分鐘前",

    // Common additions (GIV-256)
    "common.previous": "上一頁",
    "common.next": "下一頁",
    "common.pageOfTotal": "第 {{page}} 頁，共 {{total}} 頁",
    "common.retry": "重試",
    "common.processing": "處理中...",
    "common.saving": "儲存中...",
    "common.donate": "捐款",
    "common.active": "活躍",

    // Portfolio Funds - public page (GIV-256)
    "portfolio.donationType": "捐款類型",
    "portfolio.devNative": "DEV（原生）",
    "portfolio.testToken": "TEST 代幣",
    "portfolio.donationAmount": "捐款金額：",
    "portfolio.platformFee": "平台手續費（{{percentage}}%）：",
    "portfolio.toCharities": "給慈善機構：",
    "portfolio.eachCharityReceives": "每個慈善機構收到：",
    "portfolio.donateToFund": "捐款給 {{name}}",
    "portfolio.equalDistribution": "均等分配",
    "portfolio.equalDistributionNote":
      "您的捐款將在 {{count}} 個已驗證慈善機構之間均等分配。",
    "portfolio.eachCharityPercentage": "每個慈善機構收到捐款的 {{percentage}}%",
    "portfolio.verifiedCharities": "{{count}} 個已驗證慈善機構",
    "portfolio.donateToFundButton": "捐款給基金",
    "portfolio.noFundsAvailable": "目前沒有可用的投資組合基金",
    "portfolio.checkBackLater": "請稍後再來查看新的資助機會",
    "portfolio.amountLabel": "金額（{{currency}}）",
    "portfolio.invalidAmount": "請輸入有效金額",
    "portfolio.donationSuccess": "捐款成功！",
    "portfolio.donationFailed": "捐款失敗，請重試。",

    // Admin - Activity event type labels (GIV-256)
    "admin.activity.donation": "捐款",
    "admin.activity.registration": "註冊",
    "admin.activity.verification": "驗證",
    "admin.activity.volunteerHours": "志工時數",
    "admin.activity.default": "活動",

    // Admin - Dashboard page (GIV-256)
    "admin.dashboard.title": "管理儀表板",
    "admin.dashboard.alerts": "警示",
    "admin.dashboard.alertsPending": "{{count}} 個待處理",
    "admin.dashboard.alertsView": "查看",
    "admin.dashboard.recentActivity": "最近活動",
    "admin.dashboard.noRecentActivity": "沒有最近活動。",
    "admin.dashboard.quickActions": "快捷操作",
    "admin.dashboard.errorTitle": "載入管理儀表板時發生錯誤",
    "admin.stats.last7d": "近 7 天",
    "admin.stats.last30d": "近 30 天",
    "admin.stats.totalDonors": "捐款者總數",
    "admin.stats.newRegistrations": "新註冊",
    "admin.stats.charities": "慈善機構",
    "admin.stats.pendingVerification": "待驗證",
    "admin.stats.verifiedCharities": "已驗證慈善機構",
    "admin.stats.activeVolunteers": "活躍志工",
    "admin.stats.totalDonationVolume": "捐款總額",
    "admin.stats.cryptoVolume": "加密貨幣交易額",
    "admin.stats.fiatVolume": "法幣交易額",
    "admin.stats.donations": "筆捐款",

    // Admin - Quick Actions (GIV-256)
    "admin.actions.viewReports": "檢視報告",
    "admin.actions.viewReportsDesc": "產生詳細分析報告",
    "admin.actions.manageCharities": "管理慈善機構",
    "admin.actions.manageCharitiesDesc": "審核和核准組織",
    "admin.actions.systemSettings": "系統設定",
    "admin.actions.systemSettingsDesc": "設定平台參數",
    "admin.actions.manageImpactMetrics": "管理影響力指標",
    "admin.actions.manageImpactMetricsDesc": "設定影響力計算器資料",
    "admin.actions.donationMonitoring": "捐款監控",
    "admin.actions.donationMonitoringDesc": "監控、標記和報告捐款",
    "admin.actions.contentModeration": "內容審核",
    "admin.actions.contentModerationDesc": "隱藏、標記和審核機會和公益事業",
    "admin.actions.portfolioFunds": "投資組合基金",
    "admin.actions.portfolioFundsDesc": "建立和管理精選捐款組合",
    "admin.actions.charityRequests": "慈善機構請求",
    "admin.actions.charityRequestsDesc": "審核捐款者對未註冊慈善機構的請求",

    // Admin - Portfolio Funds management page (GIV-256)
    "admin.portfolio.title": "投資組合基金",
    "admin.portfolio.subtitle": "建立和管理精選捐款組合",
    "admin.portfolio.newFund": "新基金",
    "admin.portfolio.editFund": "編輯基金",
    "admin.portfolio.createNewFund": "建立新基金",
    "admin.portfolio.fundName": "基金名稱",
    "admin.portfolio.fundNamePlaceholder": "例如：環境影響基金",
    "admin.portfolio.description": "說明",
    "admin.portfolio.descriptionPlaceholder": "描述基金的目的和影響重點...",
    "admin.portfolio.category": "類別",
    "admin.portfolio.selectCategory": "選擇類別",
    "admin.portfolio.imageUrl": "圖片網址",
    "admin.portfolio.imageUrlPlaceholder": "https://...",
    "admin.portfolio.selectCharities": "選擇慈善機構（已選 {{count}} 個）",
    "admin.portfolio.noCharitiesFound": "未找到已驗證的慈善機構",
    "admin.portfolio.saving": "儲存中...",
    "admin.portfolio.createFund": "建立基金",
    "admin.portfolio.updateFund": "更新基金",
    "admin.portfolio.noFundsYet": "尚無投資組合基金",
    "admin.portfolio.noFundsMessage":
      "建立您的第一個基金，將慈善機構分組進行捐款",
    "admin.portfolio.charity": "個慈善機構",
    "admin.portfolio.charities": "個慈善機構",
    "admin.portfolio.createdOn": "建立於 {{date}}",
    "admin.portfolio.statusActive": "活躍",
    "admin.portfolio.statusPaused": "已暫停",
    "admin.portfolio.statusArchived": "已封存",
    "admin.portfolio.errorLoad": "載入資料失敗",
    "admin.portfolio.errorArchive": "封存基金失敗",
    "admin.portfolio.fundArchived": "基金已封存",
    "admin.portfolio.fundUpdated": "基金已更新",
    "admin.portfolio.fundCreated": "基金已建立",
    "admin.portfolio.errorSave": "儲存基金失敗",

    // Admin - Charity Management page (GIV-256)
    "admin.charity.title": "慈善機構管理",
    "admin.charity.totalCount": "共 {{count}} 個",
    "admin.charity.allStatuses": "所有狀態",
    "admin.charity.searchPlaceholder": "依名稱搜尋\u2026",
    "admin.charity.colName": "名稱",
    "admin.charity.colEin": "稅務編號",
    "admin.charity.taxIdDisplay": "稅務編號 {{value}}",
    "admin.charity.searchByNameEin": "依名稱或稅務編號搜尋…",
    "admin.charity.colCategory": "類別",
    "admin.charity.colStatus": "狀態",
    "admin.charity.colSigner": "聯絡人",
    "admin.charity.colJoined": "加入時間",
    "admin.charity.colWallet": "錢包",
    "admin.charity.colActions": "操作",
    "admin.charity.walletNotSet": "未設定",
    "admin.charity.approve": "核准",
    "admin.charity.reject": "拒絕",
    "admin.charity.suspend": "停權",
    "admin.charity.reinstate": "恢復",
    "admin.charity.statusPending": "待審核",
    "admin.charity.statusVerified": "已驗證",
    "admin.charity.statusApproved": "已核准",
    "admin.charity.statusRejected": "已拒絕",
    "admin.charity.statusSuspended": "已停權",
    "admin.charity.approveTitle": "核准慈善機構",
    "admin.charity.rejectTitle": "拒絕慈善機構",
    "admin.charity.suspendTitle": "停權慈善機構",
    "admin.charity.reinstateTitle": "恢復慈善機構",
    "admin.charity.confirmAction": "確認操作",
    "admin.charity.reasonRequired": "原因（必填）",
    "admin.charity.reasonOptional": "原因（選填）",
    "admin.charity.saving": "儲存中\u2026",
    "admin.charity.confirm": "確認",
    "admin.charity.noResults": "未找到符合篩選條件的慈善機構。",
    "admin.charity.unnamed": "未命名組織",

    // Admin - Charity Requests page (GIV-256)
    "admin.charityRequests.title": "慈善機構請求",
    "admin.charityRequests.subtitle":
      "捐款者提交的未認領慈善機構請求，依組織分組。應優先聯繫關注度最高的組織。",
    "admin.charityRequests.ein": "稅務編號",
    "admin.charityRequests.requests": "請求數",
    "admin.charityRequests.latestRequester": "最近請求者",
    "admin.charityRequests.latestRequest": "最近請求",
    "admin.charityRequests.firstRequest": "首次請求",
    "admin.charityRequests.empty": "尚未提交任何慈善機構請求。",
    "admin.charityRequests.errorTitle": "載入慈善機構請求時發生錯誤",
    "admin.charityRequests.showing": "顯示 {{shown}} / {{total}} 個唯一組織。",

    // Admin - Volunteer Validation page (GIV-256)
    "admin.validation.title": "志工驗證監督",
    "admin.validation.totalCount": "共 {{count}} 個請求",
    "admin.validation.pipelineStats": "流程統計",
    "admin.validation.noStats": "目前沒有統計資料。",
    "admin.validation.pending": "待處理",
    "admin.validation.approved": "已核准",
    "admin.validation.rejected": "已拒絕",
    "admin.validation.expired": "已逾期",
    "admin.validation.avgResponseTime": "平均回應時間：",
    "admin.validation.expirationRate": "逾期率：",
    "admin.validation.rejectionRate": "拒絕率：",
    "admin.validation.searchPlaceholder": "搜尋志工、組織\u2026",
    "admin.validation.requestsTab": "驗證請求",
    "admin.validation.patternsTab": "可疑模式",
    "admin.validation.colVolunteer": "志工",
    "admin.validation.colOrganisation": "組織",
    "admin.validation.colHours": "時數",
    "admin.validation.colActivityDate": "活動日期",
    "admin.validation.colHrsPerWeek": "時/週",
    "admin.validation.colTotalRequests": "請求總數",
    "admin.validation.override": "覆寫",
    "admin.validation.noPatterns": "未偵測到可疑模式。",
    "admin.validation.noRequests": "未找到驗證請求。",
    "admin.validation.patternsDescription":
      "標記在滾動 7 天窗口內回報超過設定閾值時數的志工。這些模式可能表示自行回報時數系統遭到濫用。",
    "admin.validation.overrideTitle": "覆寫驗證請求",
    "admin.validation.newStatus": "新狀態",
    "admin.validation.reasonRequired": "原因（必填）",
    "admin.validation.reasonPlaceholder": "說明覆寫此請求的原因\u2026",
    "admin.validation.saving": "儲存中\u2026",
    "admin.validation.confirmOverride": "確認覆寫",
    "admin.validation.allStatuses": "所有狀態",
    "admin.validation.colStatus": "狀態",
    "admin.validation.colCreated": "建立時間",

    // GIV-266: Delta translations (354 keys)
    "home.hero.title": "透明捐贈",
    "home.hero.titleAccent": "永續影響力",
    "home.hero.description":
      "為數位時代打造的全透明公益慈善。以影響力為核心，以可驗證技術為後盾。每一筆捐款皆可追溯，從捐贈者直達受助對象。",
    "home.hero.visionTitle": "我們的願景",
    "home.hero.visionText":
      "Give Protocol 正在建構高誠信捐贈的未來。我們運用先進的技術基礎設施，連接全球資本與在地影響力。透過將無縫的數位資產支援與傳統捐贈方式整合，我們正在創建富有韌性的資金生態系統，將一次性的捐贈轉化為永續的支持引擎，為世界上最重要的公益事業提供長期資助。",
    "home.comingSoon": "即將推出",
    "home.readDocs": "閱讀文件",
    "home.features.sectionTitle": "您通往透明公益的入口",
    "home.features.sectionSubtitle":
      "多鏈基礎設施實現無縫捐贈——加密貨幣或法定貨幣皆可——全程透明",
    "home.features.highEfficiency.title": "高效率捐贈",
    "home.features.highEfficiency.description":
      "直接捐贈給經過驗證的組織，完全透明無疑慮。我們的自動化帳本提供即時驗證，確保您的支持精準送達最需要的地方。",
    "home.features.equityFunds.title": "慈善權益基金",
    "home.features.equityFunds.description":
      "超越一次性捐贈，投入智慧管理的權益基金。我們運用精密的低風險數位策略，將您的本金轉化為永續的資金流，為慈善使命提供代代相傳的支持。",
    "home.features.impactFunds.title": "影響力基金",
    "home.features.impactFunds.description":
      "為特定公益目標匯集資源。環境保護、教育、扶貧——透過集體行動放大您的捐款效益。",
    "home.features.verifiedOrgs.title": "已驗證組織",
    "home.features.verifiedOrgs.description":
      "瀏覽任何已登記的組織，或查看驗證徽章。選擇加入我們審查流程的組織將獲得鏈上驗證，值得捐贈者信賴。",
    "home.features.blockchainVerified.title": "區塊鏈驗證",
    "home.features.blockchainVerified.description":
      "靈魂綁定代幣記錄志工貢獻。技能、時數和影響力——全部永久記錄在鏈上。",
    "home.features.bridgingModes.title": "連結多元捐贈方式",
    "home.features.bridgingModes.description":
      "無論您是以 USD 或數位資產捐贈，我們的多網路架構確保您的捐款以現代世界的速度流轉。",
    "home.roles.title": "為每位改變世界的人而打造",
    "home.roles.donors.title": "捐贈者專區",
    "home.roles.donors.item1": "加密貨幣或法定貨幣——由您選擇",
    "home.roles.donors.item2": "參與治理決策",
    "home.roles.donors.item3": "建立鏈上信譽",
    "home.roles.nonprofits.title": "非營利組織專區",
    "home.roles.nonprofits.item1": "觸及全新捐贈族群",
    "home.roles.nonprofits.item2": "透過 CEF 實現永續資金",
    "home.roles.nonprofits.item3": "強化透明度報告",
    "home.roles.volunteers.title": "志工專區",
    "home.roles.volunteers.item1": "可驗證的貢獻記錄",
    "home.roles.volunteers.item2": "可攜式技能憑證 (SBT)",
    "home.roles.volunteers.item3": "成就徽章與表彰",
    "home.impact.title": "規劃中的影響力基金",
    "home.impact.environmental.title": "環境影響力基金",
    "home.impact.environmental.description":
      "支持造林、海洋清潔和再生能源計畫。匯集捐款，定向資助經過驗證、具有可衡量成效的環保組織。",
    "home.impact.education.title": "教育機會基金",
    "home.impact.education.description":
      "提供獎學金、數位學習工具和師資培訓。集結資金，放大支持力度，幫助資源不足社區的教育計畫。",
    "home.cta.title": "準備好改變捐贈方式了嗎？",
    "home.cta.subtitle":
      "成為率先體驗透明、區塊鏈驅動公益的一員。加入我們的社群，共同為慈善捐贈打造更美好的未來。",
    "home.cta.explore": "探索公益專案",
    "home.nav.features": "功能特色",
    "home.nav.impact": "影響力",
    "home.nav.charities": "慈善機構",
    "home.nav.volunteer": "志工服務",
    "home.footer.brand.tagline": "透過區塊鏈透明度與永續資金，改變公益慈善。",
    "home.footer.product.title": "產品",
    "home.footer.product.impactFunds": "影響力基金",
    "home.footer.product.charities": "慈善機構專區",
    "home.footer.product.volunteers": "志工專區",
    "home.footer.resources.title": "資源",
    "home.footer.resources.whitepaper": "白皮書（即將推出）",
    "home.footer.resources.blog": "部落格（即將推出）",
    "home.footer.resources.community": "社群（即將推出）",
    "home.footer.connect.title": "聯繫我們",
    "home.footer.connect.contact": "聯絡方式（即將推出）",
    "home.footer.copyright":
      "Give Protocol。多鏈設計。由 Give Protocol 志工驅動。",
    "auth.signin.welcomeBack": "歡迎回來",
    "auth.signin.subtitle": "登入您的 Give Protocol 帳戶",
    "auth.signin.emailPlaceholder": "電子郵件",
    "auth.signin.passwordPlaceholder": "密碼",
    "auth.signin.submitting": "登入中…",
    "auth.signin.withPasskey": "使用通行密鑰登入",
    "auth.signin.withGoogle": "透過 Google 繼續",
    "auth.signin.or": "或",
    "auth.signin.newToProtocol": "初次使用 Give Protocol？",
    "auth.signin.createAccount": "建立帳戶 →",
    "auth.signin.forgotPasswordLink": "忘記密碼？ →",
    "auth.signin.sslEncrypted": "TLS 加密",
    "auth.signin.modeToggleLabel": "登入方式",
    "auth.signin.terms": "服務條款",
    "auth.signin.privacy": "隱私權",
    "auth.panel.headline": "智慧捐贈，透明成效。",
    "auth.panel.subheadline":
      "一個帳戶。信用卡或加密貨幣捐贈。每一分錢鏈上可追蹤。",
    "auth.panel.statusLabel": "協議狀態 · 創始階段",
    "auth.panel.statusDesc": "建構透明捐贈的基礎",
    "auth.panel.runsOn": "運行於",
    "auth.wallet.connect": "連接錢包",
    "auth.wallet.connecting": "正在連接錢包…",
    "auth.wallet.signing": "正在簽署訊息…",
    "auth.wallet.verifying": "驗證中…",
    "auth.wallet.openingSession": "正在開啟工作階段…",
    "auth.validation.emailRequired": "請先輸入您的電子郵件地址",
    "auth.validation.invalidEmail": "請輸入有效的電子郵件地址",
    "auth.validation.passwordTooShort": "密碼長度至少需要 8 個字元",
    "auth.validation.passwordMismatch": "兩次輸入的密碼不一致",
    "auth.login.welcomeHeading": "歡迎來到 Give Protocol",
    "auth.login.signInOrConnect": "登入或連接",
    "auth.login.skipToContent": "跳至登入內容",
    "auth.login.donorTitle": "捐贈者登入",
    "auth.login.donorSubtitle": "登入以存取您的捐贈儀表板",
    "auth.login.charityTitle": "非營利組織入口",
    "auth.login.charitySubtitle": "管理您的組織資料與捐款",
    "auth.login.back": "← 返回",
    "auth.login.continueDonor": "以捐贈者身分繼續",
    "auth.login.connecting": "連接中…",
    "auth.login.connectWalletSignIn": "連接錢包並登入",
    "auth.login.newToPlatform": "初次使用 Give Protocol？",
    "auth.login.newDonorSignUp": "新捐贈者註冊",
    "auth.login.manageNonprofit": "我管理一個非營利組織",
    "auth.login.nonprofitTrayTitle": "初次使用 Give Protocol？",
    "auth.login.createNonprofitAccount": "建立非營利組織帳戶",
    "auth.login.registerOrg": "在 Give Protocol 上註冊您的組織",
    "auth.login.needHelp": "需要協助？",
    "auth.login.forgotUsernameBtn": "忘記使用者名稱？",
    "auth.login.forgotPasswordBtn": "忘記密碼？",
    "auth.donorLogin.mismatch":
      "找不到捐贈者帳戶。此電子郵件已註冊為慈善機構帳戶，請使用慈善機構登入。",
    "auth.donorLogin.signingIn": "登入中…",
    "auth.donorLogin.redirecting": "將在 {{count}} 秒後重新導向...",
    "auth.donorReg.pleaseWait": "請稍候…",
    "auth.donorReg.signUpPasskey": "使用通行密鑰註冊",
    "auth.donorReg.withGoogle": "透過 Google 繼續",
    "auth.donorReg.connectWallet": "連接錢包",
    "auth.donorReg.orSetPassword": "或設定密碼",
    "auth.donorReg.creating": "正在建立帳戶...",
    "auth.donorReg.createAccount": "建立捐贈者帳戶",
    "auth.donorReg.privacyNotice": "建立帳戶即表示您同意我們的",
    "auth.donorReg.termsLink": "服務條款",
    "auth.donorReg.privacyAnd": "並確認我們的",
    "auth.donorReg.privacyLink": "隱私政策",
    "auth.charityLogin.mismatch":
      "此電子郵件已註冊為捐贈者帳戶，請至捐贈者入口登入。",
    "auth.charityLogin.signingIn": "登入中...",
    "auth.charityLogin.or": "或",
    "auth.charityLogin.connecting": "連接中...",
    "auth.charityLogin.connectWallet": "連接錢包",
    "auth.forgot.resetPassword": "重設密碼",
    "auth.forgot.forgotUsername": "忘記使用者名稱",
    "auth.forgot.passwordDesc":
      "請輸入您的電子郵件地址，我們將寄送密碼重設連結給您。",
    "auth.forgot.usernameDesc":
      "請輸入您的電子郵件地址，我們將寄送您的使用者名稱給您。",
    "auth.forgot.passwordSuccess": "密碼重設指示已寄送至您的電子郵件",
    "auth.forgot.usernameSuccess": "使用者名稱提醒已寄送至您的電子郵件",
    "auth.forgot.checkEmail": "請查看您的電子郵件",
    "auth.forgot.backToSignIn": "返回登入",
    "auth.forgot.emailPlaceholder": "輸入您的電子郵件地址",
    "auth.forgot.genericError": "發生錯誤，請再試一次。",
    "auth.forgot.sending": "傳送中...",
    "auth.forgot.sendResetLink": "傳送重設連結",
    "auth.forgot.sendUsername": "傳送使用者名稱",

    // Reset password (set new password page) — pending translation (GIV-367)
    "auth.resetPassword.title": "Set New Password",
    "auth.resetPassword.subtitle": "Choose a strong password for your account.",
    "auth.resetPassword.newPassword": "New Password",
    "auth.resetPassword.confirmPassword": "Confirm New Password",
    "auth.resetPassword.submit": "Update Password",
    "auth.resetPassword.updating": "Updating\u2026",
    "auth.resetPassword.mismatch": "Passwords do not match.",
    "auth.resetPassword.success": "Password updated successfully!",
    "auth.resetPassword.successSubtitle":
      "You can now sign in with your new password.",
    "auth.resetPassword.backToSignIn": "Back to Sign In",
    "auth.resetPassword.invalidLink":
      "This password reset link is invalid or has expired.",
    "auth.resetPassword.requestNew": "Request a new reset link",
    "auth.resetPassword.validating": "Validating reset link\u2026",
    "auth.orgSearch.orgNameLabel": "組織名稱",
    "auth.orgSearch.searchPlaceholder": "依組織名稱搜尋...",
    "auth.orgSearch.countryLabel": "國家",
    "auth.orgSearch.allCountries": "所有國家",
    "auth.orgSearch.searchPrompt": "搜尋我們的資料庫以尋找並認領您的組織。",
    "auth.orgSearch.noResults": "找不到相關組織。",
    "auth.orgSearch.loadMore": "載入更多結果",
    "auth.orgSearch.cantFind": "找不到您的組織？",
    "auth.orgSearch.registerManually": "手動註冊",
    "charity.claim.orgDetails": "組織資訊（來自登記資料）",
    "charity.claim.orgNameLabel": "名稱",
    "charity.claim.einLabel": "稅務編號",
    "charity.claim.locationLabel": "所在地",
    "charity.claim.contactInfo": "聯絡資訊",
    "charity.claim.contactName": "聯絡人姓名",
    "charity.claim.contactEmail": "聯絡電子郵件",
    "charity.claim.accountSecurity": "帳戶安全",
    "charity.claim.password": "密碼",
    "charity.claim.confirmPassword": "確認密碼",
    "charity.claim.backToSearch": "返回搜尋",
    "charity.claim.creating": "正在建立帳戶...",
    "charity.claim.submit": "認領組織",
    "charity.claim.validation.name": "名稱長度需介於 2 至 100 個字元之間",
    "charity.claim.validation.email": "請輸入有效的電子郵件地址",
    "charity.claim.validation.password": "密碼長度至少需要 8 個字元",
    "charity.claim.validation.confirmPassword": "兩次輸入的密碼不一致",
    "charity.claim.validation.fix": "請修正驗證錯誤",
    "charity.claim.useAsPublicEmail": "使用我的電子郵件作為組織的公開聯絡郵箱",
    "charity.claim.publicContactEmail": "組織公開聯絡電子郵件",
    "charity.claim.privacyNotice":
      "您的個人簽署人電子郵件/電話僅用於驗證，其他平台使用者無法看到。公開聯絡電子郵件將顯示在您的組織檔案中。",
    "charity.claim.secondContactTitle": "第二聯絡人",
    "charity.claim.secondContactName": "第二聯絡人姓名",
    "charity.claim.secondContactEmail": "第二聯絡人電子郵件",
    "charity.claim.secondContactHint":
      "另一位聯絡人，當您慈善機構的錢包或收款資訊變更時接收通知。",
    "charity.claim.validation.secondEmailDistinct":
      "第二聯絡人電子郵件必須與主要電子郵件不同",
    "charity.claim.error.creation": "帳戶建立失敗",
    "charity.claim.error.generic": "無法建立帳戶",
    "charity.vetting.orgDetails": "組織資訊",
    "charity.vetting.orgName": "組織名稱",
    "charity.vetting.description": "描述",
    "charity.vetting.taxId": "稅務或登記編號",
    "charity.vetting.countryLabel": "國家",
    "charity.vetting.selectCountry": "選擇國家",
    "charity.vetting.address": "地址",
    "charity.vetting.streetAddress": "街道地址",
    "charity.vetting.city": "城市",
    "charity.vetting.state": "州/省",
    "charity.vetting.postalCode": "郵遞區號",
    "charity.vetting.contactInfo": "聯絡資訊",
    "charity.vetting.contactName": "聯絡人姓名",
    "charity.vetting.contactEmail": "聯絡電子郵件",
    "charity.vetting.accountSecurity": "帳戶安全",
    "charity.vetting.password": "密碼",
    "charity.vetting.confirmPassword": "確認密碼",
    "charity.vetting.submitting": "正在提交申請...",
    "charity.vetting.submit": "提交慈善機構申請",
    "charity.vetting.validation.orgName":
      "組織名稱長度需介於 2 至 100 個字元之間",
    "charity.vetting.validation.contactName":
      "聯絡人姓名長度需介於 2 至 100 個字元之間",
    "charity.vetting.validation.email": "請輸入有效的電子郵件地址",
    "charity.vetting.validation.password": "密碼長度至少需要 8 個字元",
    "charity.vetting.validation.confirmPassword": "兩次輸入的密碼不一致",
    "charity.vetting.validation.description": "描述為必填欄位",
    "charity.vetting.validation.category": "類別為必填欄位",
    "charity.vetting.validation.taxId": "稅務編號為必填欄位",
    "charity.vetting.validation.streetAddress": "街道地址為必填欄位",
    "charity.vetting.validation.city": "城市為必填欄位",
    "charity.vetting.validation.country": "國家為必填欄位",
    "charity.vetting.validation.fix": "請修正驗證錯誤",
    "charity.vetting.error.generic": "無法提交申請",
    "charity.vetting.privacyNotice": "提交此申請即表示您同意我們的",
    "charity.vetting.termsLink": "服務條款",
    "charity.vetting.privacyAnd": "並確認我們的",
    "charity.vetting.privacyLink": "隱私政策",
    "common.email": "電子郵件",
    "common.password": "密碼",
    "common.confirmPassword": "確認密碼",
    "footer.brand.tagline": "消除永續慈善捐贈的障礙。",
    "footer.resources.title": "資源",
    "footer.resources.faq": "常見問題",
    "footer.resources.about": "關於我們",
    "footer.legal.title": "法律資訊",
    "footer.legal.terms": "服務條款",
    "footer.legal.privacy": "隱私權政策",
    "footer.legal.cookiePreferences": "Cookie 偏好設定",
    "consent.banner.ariaLabel": "Cookie 同意",
    "consent.banner.body":
      "我們使用 Google Analytics 4（Google LLC，美國）和 Sentry（Functional Software，美國/歐盟）來瞭解應用程式的使用情況並偵測錯誤。不會分享任何電子郵件地址、錢包地址或捐贈者姓名。您可以隨時撤回同意。",
    "consent.banner.privacyLink": "隱私權政策",
    "consent.banner.acceptAll": "全部接受",
    "consent.banner.decline": "拒絕非必要",
    "consent.banner.customize": "自訂",
    "consent.modal.title": "Cookie 偏好設定",
    "consent.modal.essentialTitle": "必要",
    "consent.modal.essentialDesc":
      "網站核心功能（如導覽和身分驗證）所必需。無法停用。",
    "consent.modal.essentialAlwaysOn": "必要 Cookie — 始終啟用",
    "consent.modal.analyticsTitle":
      "分析（Google Analytics 4 · 美國，Sentry · 美國/歐盟）",
    "consent.modal.analyticsDesc":
      "分析 Cookie 幫助我們瞭解哪些頁面被瀏覽以及使用者如何在應用程式中導覽。我們使用 Google Analytics 4 \u2014 工作階段識別碼、頁面 URL、裝置/瀏覽器中繼資料、從匿名化 IP 取得的大致位置（Google LLC，美國；SCCs + EU\u2013US Data Privacy Framework）。Sentry \u2014 用於可靠性監控的匿名化錯誤追蹤和瀏覽器中繼資料（Functional Software，歐盟/美國；傳輸機制待定）。不會與任何處理者分享電子郵件地址、錢包地址或捐贈者姓名。",
    "consent.modal.analyticsOn": "分析與錯誤記錄 — 已開啟",
    "consent.modal.analyticsOff": "分析與錯誤記錄 — 已關閉",
    "consent.modal.cancel": "取消",
    "consent.modal.save": "儲存偏好設定",
    "footer.connect.title": "聯繫我們",
    "footer.copyright": "Give Protocol。版權所有。",
    "nav.signIn": "登入",
    "nav.signOut": "登出",
    "nav.privacy": "隱私權",
    "auth.signup.heading": "建立您的帳戶",
    "auth.signup.subtitle": "加入透明捐贈運動",
    "auth.signup.displayName": "顯示名稱",
    "auth.signup.emailPlaceholder": "電子郵件",
    "auth.signup.passwordPlaceholder": "密碼",
    "auth.signup.confirmPasswordPlaceholder": "確認密碼",
    "auth.signup.submit": "建立帳戶",
    "auth.signup.submitting": "正在建立帳戶…",
    "auth.signup.withPasskey": "使用通行密鑰註冊",
    "auth.signup.withGoogle": "透過 Google 繼續",
    "auth.signup.connectWallet": "連接錢包",
    "auth.signup.orSetPassword": "或設定密碼",
    "auth.signup.alreadyHaveAccount": "已經有帳戶了？",
    "auth.signup.signInLink": "登入",
    "auth.signup.manageNonprofit": "管理非營利組織？",
    "auth.signup.trustText": "您的資料受到以下保護",
    "auth.signup.and": "和",
    "auth.signup.privacyPolicy": "隱私權政策",
    "auth.signup.panel.headline": "可驗證的捐贈。",
    "browse.hero.title": "鏈上驗證的捐贈。",
    "browse.hero.subtitle":
      "發掘經過篩選的事業，透過卡片或數位資產捐款，並看到你的時間和資源帶來的具體影響。",
    "browse.stats.networks": "支援的網路",
    "browse.stats.sectors": "慈善領域",
    "browse.stats.verifiedOrgs": "已驗證組織",
    "browse.stats.volunteerHours": "志工時數",
    "browse.verified": "已驗證",
    "browse.donate": "捐贈",
    "browse.viewProfile": "查看檔案",
    "browse.filter.ariaLabel": "篩選慈善機構",
    "browse.filter.searchAria": "搜尋慈善機構",
    "browse.filter.locationAria": "搜尋地點",
    "browse.results.ariaLabel": "慈善機構結果",
    "browse.tabs.charities": "慈善機構",
    "browse.tabs.causes": "公益專案",
    "browse.tabs.funds": "投資組合基金",
    "browse.tabs.ariaLabel": "瀏覽分類",
    "browse.featured.heading": "精選組織",
    "browse.featured.ariaLabel": "精選組織",
    "browse.featured.nextAria": "下一批精選組織",
    "browse.causes.heading": "精選公益專案",
    "browse.causes.ariaLabel": "精選公益專案",
    "browse.causes.badge": "公益專案",
    "browse.causes.raised": "已募集",
    "browse.causes.percentOf": "% 的",
    "browse.causes.by": "由",
    "browse.causes.supportCta": "支持此專案",
    "browse.causes.giveCta": "捐贈",
    "browse.causes.nextAria": "下一批精選公益專案",
    "browse.funds.heading": "投資組合基金",
    "browse.funds.ariaLabel": "投資組合基金",
    "browse.funds.badge": "投資組合基金",
    "browse.funds.charity": "個慈善機構",
    "browse.funds.charities": "個慈善機構",
    "browse.funds.donateCta": "捐贈至基金",
    "browse.funds.nextAria": "下一批投資組合基金",
    "portfolio.notFound.title": "找不到投資組合基金",
    "portfolio.notFound.body": "您查找的投資組合基金不存在或已不再活躍。",
    "portfolio.supportedOrgs": "支持的機構",
    "browse.charity.einLabel": "稅務編號",
    "browse.charity.einDisplay": "稅務編號：{{value}}",
    "browse.charity.nteeLabel": "行業代碼",
    "browse.charity.deductibilityLabel": "可抵稅性",
    "browse.charity.onPlatform": "平台上",
    "browse.charity.loading": "載入中…",
    "browse.charity.loadMore": "載入更多",
    "browse.filter.searchPlaceholder": "搜尋慈善機構...",
    "browse.filter.locationPlaceholder": "城市、省份或國家...",
    "browse.whyGiveProtocol.heading": "為什麼選擇 Give Protocol？",
    "browse.whyGiveProtocol.verified.title": "經過驗證的非營利組織",
    "browse.whyGiveProtocol.verified.description":
      "每個組織在出現在平台上之前都會與公共註冊資訊進行核實。",
    "browse.whyGiveProtocol.onchain.title": "鏈上透明度",
    "browse.whyGiveProtocol.onchain.description":
      "捐款記錄在區塊鏈上，讓您可以從錢包到公益事業全程追蹤您的影響。",
    "browse.whyGiveProtocol.volunteer.title": "捐出時間，不只是金錢",
    "browse.whyGiveProtocol.volunteer.description":
      "志願服務時間由慈善機構驗證，並計入您的協議聲譽。",
    "browse.news.heading": "平台動態",
    "admin.news.deleteConfirmBody": "「{{title}}」將被永久刪除，此操作無法復原。",
    "admin.news.deleteConfirmTitle": "刪除這則動態？",
    "admin.news.saveFailed": "無法儲存您的變更，請再試一次。",
    "admin.news.urlHelp": "選填。留空則顯示不含連結的動態。",
    "admin.news.urlInvalid": "請輸入完整的 https:// 網址，或以 / 開頭的路徑。",
    "browse.carousel.error": "無法載入此區塊，請重新整理頁面後再試。",
    "browse.carousel.goToPage": "前往第 {{page}} 頁",
    "browse.carousel.pageLabel": "第 {{current}} 頁，共 {{total}} 頁",
    "browse.carousel.pause": "暫停自動輪播",
    "browse.carousel.play": "繼續自動輪播",
    "browse.causes.empty": "目前尚無公益專案，請稍後再來查看！",
    "browse.causes.prevAria": "上一組精選公益專案",
    "browse.causes.searchPlaceholder": "搜尋公益專案...",
    "browse.causes.subheading": "支持能產生實際影響的具體專案。",
    "browse.charity.registryIdDisplay": "登記編號：{{value}}",
    "browse.featured.empty": "目前尚無精選機構。請使用上方搜尋尋找慈善機構。",
    "browse.featured.prevAria": "上一組精選機構",
    "browse.featured.subheading": "輪播展示 Give Protocol 上已驗證的慈善機構。",
    "browse.filter.addLocation": "新增地點",
    "browse.filter.impactNotice": "影響地區篩選目前尚未提供，因此結果不會依影響地區縮小範圍。",
    "browse.filter.locationHint": "按 Enter 鍵或選擇「新增」以套用地點。",
    "browse.filter.minChars": "請至少輸入 2 個字元進行搜尋。",
    "browse.funds.empty": "目前尚無投資組合基金，請稍後再來查看！",
    "browse.funds.prevAria": "上一組投資組合基金",
    "browse.funds.searchPlaceholder": "搜尋投資組合基金...",
    "browse.funds.subheading": "精選的捐贈組合，將捐款分配給已驗證的慈善機構。",
    "browse.registry.badge": "已於{{registry}}登記",
    "browse.results.empty": "沒有符合該搜尋的機構。請嘗試其他關鍵字或新增地點篩選。",
    "browse.results.error": "無法執行該搜尋，請再試一次。",
    "browse.search.noMatches": "沒有符合「{{query}}」的內容。",
    "browse.category.A": "藝術與文化",
    "browse.category.B": "教育",
    "browse.category.C": "環境",
    "browse.category.D": "動物福利",
    "browse.category.E": "健康",
    "browse.category.F": "心理健康",
    "browse.category.G": "醫學研究",
    "browse.category.H": "生物醫學研究",
    "browse.category.I": "犯罪與法律",
    "browse.category.J": "就業",
    "browse.category.K": "食品與營養",
    "browse.category.L": "住宅",
    "browse.category.M": "公共安全",
    "browse.category.N": "休閒娛樂",
    "browse.category.O": "青少年發展",
    "browse.category.P": "人群服務",
    "browse.category.Q": "國際",
    "browse.category.R": "公民權利",
    "browse.category.S": "社區發展",
    "browse.category.T": "慈善事業",
    "browse.category.U": "科學與技術",
    "browse.category.V": "社會科學",
    "browse.category.W": "公共政策",
    "browse.category.X": "宗教",
    "browse.category.Y": "互助",
    "browse.category.default": "非營利組織",
    "cause.causes": "公益專案",
    "cause.createNew": "新增",
    "cause.noCausesTitle": "尚無公益專案",
    "cause.name": "名稱",
    "cause.description": "描述",
    "cause.category": "類別",
    "cause.targetAmount": "目標金額",
    "cause.headerImage": "標題圖片",
    "cause.impact": "影響力",
    "cause.impactHelp": "描述此公益專案的預期影響。",
    "cause.location": "地點",
    "cause.timeline": "時間表",
    "cause.partners": "合作夥伴",
    "cause.limitReached": "已達公益專案上限",
    "impact.statistics": "影響力統計",
    "impact.statLabel": "標籤",
    "impact.statValue": "數值",
    "impact.missionStatement": "使命宣言",
    "impact.missionPlaceholder": "我們的使命是…",
    "impact.highlights": "影響力亮點",
    "impact.highlight": "影響力亮點",
    "impact.addHighlight": "新增亮點",
    "impact.profile": "影響力檔案",
    "impact.loadError": "無法載入影響力檔案",
    "impact.saveError": "無法儲存影響力檔案",
    "impact.saveSuccess": "影響力檔案已成功儲存",
    "organization.yearFounded": "成立年份",
    "organization.address": "地址",
    "organization.street": "街道地址",
    "organization.city": "城市",
    "organization.stateProvince": "州/省",
    "organization.postalCode": "郵遞區號",
    "organization.country": "國家",
    "organization.contactInfo": "聯絡資訊",
    "organization.phone": "電話",
    "organization.email": "電子郵件",
    "organization.website": "網站",
    "organization.socialMedia": "社群媒體",
    "organization.publicFeed": "公開動態",
    "organization.communityMedia": "社群與媒體",
    "organization.profile": "組織檔案",
    "organization.loadError": "無法載入組織檔案",
    "organization.saveError": "無法儲存組織檔案",
    "common.remove": "移除",
    "common.saveChanges": "儲存變更",
    "dashboard.thisMonth": "本月",
    "dashboard.verified": "已驗證志工",
    "dashboard.hoursLogged": "已記錄時數",
    "dashboard.endorsements": "推薦",
    "dashboard.organizationsHelped": "受助組織",
    "dashboard.yourOrganizationsHelped": "您協助過的組織",
    "transactions.createCampaign": "建立您的第一個募款活動",
    "contributions.emptyTitle": "您的捐贈之旅從這裡開始",
    "contributions.browseCharities": "瀏覽慈善機構",
    "charity.profile.verified501c3": "已驗證非營利組織",
    "charity.profile.verified501c3Tooltip":
      "已註冊 501(c)(3) — 在美國捐款可能可以抵扣稅款",
    "charity.profile.statusClaimed": "已認領",
    "charity.profile.statusUnclaimed": "未認領 — 僅有公共登記資料",
    "charity.profile.statusIrsVerified": "IRS已驗證非營利組織",
    "charity.profile.requestWidget.unclaimedBody":
      "此組織尚未在 Give Protocol 上認領其檔案。此組織完成檔案認領與錢包設定後，即可接受捐贈。",
    "charity.profile.rowEin": "稅務編號",
    "charity.profile.rowName": "名稱",
    "charity.profile.rowLocation": "所在地",
    "charity.profile.rowRulingYear": "註冊年份",
    "charity.profile.rowNteeCode": "行業代碼",
    "charity.profile.rowDeductibility": "可抵稅性",
    "charity.profile.rowAffiliation": "隸屬關係",
    "charity.profile.rowClassification": "分類",
    "charity.profile.rowFoundation": "基金會類型",
    "charity.profile.rowActivityCodes": "活動代碼",
    "charity.profile.rowOrgType": "組織類型",
    "charity.profile.rowSubsection": "條款細分",
    "charity.profile.rowStatus": "狀態",
    "charity.profile.registryRecord": "登記處公開記錄",
    "charity.profile.einDisplay": "稅務編號",
    "charity.profile.charityNotFoundByTaxId":
      "我們找不到使用此稅務編號的慈善機構。",
    "charity.profile.registeredNonprofit": "已註冊非營利組織",
    "charity.profile.registeredYear": "{{year}} 年登記",
    "charity.profile.shareAria": "分享",
    "charity.profile.copied": "已複製！",
    "charity.profile.about": "關於",
    "charity.profile.claimProfile": "認領此檔案",
    "charity.profile.noDescription": "暫無描述。",
    "charity.profile.toAddOne": "以新增描述。",
    "charity.profile.contact": "聯絡",
    "charity.profile.donate.support": "支持",
    "charity.profile.donate.walletUnset": "此組織尚未設定官方收款錢包。",
    "charity.profile.donate.walletPending":
      "此組織正在完成錢包設定 — 捐款暫時無法使用。",
    "charity.profile.donate.walletLegacy": "此組織正在使用舊版錢包地址。",
    "charity.profile.donate.feeNote": "直接捐款平台費用為0%。適用網路費用。",
    "charity.profile.donate.jurisdictionUnavailable":
      "Give Protocol 目前暫不支援對美國以外慈善機構的捐款。",
    "portfolio.title": "投資組合基金",
    "settings.displayPreferences": "顯示偏好",
    "settings.theme": "主題",
    "settings.light": "淺色",
    "settings.dark": "深色",
    "auth.toast.welcomeBack": "Welcome back, {{firstName}}",
    "auth.toast.youreSignedIn": "You're signed in.",
    "auth.toast.walletConnected": "Wallet connected",
    "auth.toast.signedInWith": "Signed in with {{address}}.",
    "auth.toast.signedOut": "Signed out",
    "auth.toast.signInFailed": "Sign-in failed",
    "auth.toast.signOutFailed": "Sign-out failed",
    "donation.toast.received": "Donation received",
    "donation.toast.receivedMessage":
      "Thank you — your tax receipt is on the way.",
    "donation.toast.submitted": "Transaction submitted",
    "donation.toast.submittedMessage": "Waiting for on-chain confirmation…",
    "donation.toast.confirmed": "Donation confirmed",
    "donation.toast.confirmedMessage":
      "Your contribution is recorded on-chain.",
    "donation.toast.failed": "Donation failed",

    // Art. 9(2)(a) donation consent (GIV-655)
    "donation.art9Consent.statement":
      "我瞭解我的捐款記錄將我與{{charity}}連結。若此舉可能顯示宗教、政治或哲學方面的歸屬關係，我明確同意Give Protocol處理此記錄以完成及管理我的捐款。",
    "donation.art9Consent.label": "捐款資料同意",
    "donation.art9Consent.required": "您必須同意捐款資料處理才能繼續。",

    "charity.toast.verificationEmailSent": "Verification email sent",
    "charity.toast.verificationEmailMessage":
      "Check your inbox — the link expires in 24 hours.",
    "charity.toast.submissionFailed": "Submission failed",

    "privacy.security.auditLog":
      "作為GDPR第32條規定的技術措施，我們記錄並監控對個人資料的管理存取——包括所執行的操作及其發生時間——以偵測未經授權的存取、證明問責制，並在萬一發生個人資料外洩（第34條）時重建事件。捐款者的個人資料不會被複製到這些管理存取日誌中。管理存取日誌與§7.1中描述的身分驗證和安全日誌不同；其保留期限由我們的內部處理活動紀錄管理。",

    // Remaining i18n keys — batch translation
    "admin.auditTrail.filterByAction": "依操作篩選",
    "admin.auditTrail.allActions": "所有操作",
    "admin.auditTrail.action.charityStatusChange": "慈善機構狀態變更",
    "admin.auditTrail.action.userStatusChange": "使用者狀態變更",
    "admin.auditTrail.action.donationFlag": "捐款標記",
    "admin.auditTrail.action.donationFlagResolve": "捐款標記解決",
    "admin.auditTrail.action.validationOverride": "驗證覆寫",
    "admin.auditTrail.action.configChange": "設定變更",
    "admin.auditTrail.action.verificationApprove": "驗證核准",
    "admin.auditTrail.action.verificationReject": "驗證拒絕",
    "admin.auditTrail.action.charitySuspend": "慈善機構暫停",
    "admin.auditTrail.action.charityReinstate": "慈善機構恢復",
    "admin.auditTrail.action.userSuspend": "使用者暫停",
    "admin.auditTrail.action.userReinstate": "使用者恢復",
    "admin.auditTrail.action.userBan": "使用者封禁",
    "admin.auditTrail.action.viewPii": "檢視個人識別資訊",
    "admin.auditTrail.action.viewPiiList": "檢視個人識別資訊清單",
    "admin.auditTrail.viewedEntity":
      "管理員 {{adminId}} 檢視了 {{entityType}} {{entityId}}",
    "admin.auditTrail.viewedList":
      "管理員 {{adminId}} 檢視了 {{entityType}} 清單（第 {{page}} 頁，篩選條件：{{filters}}）",
    "admin.auditTrail.viewedListNoFilters":
      "管理員 {{adminId}} 檢視了 {{entityType}} 清單（第 {{page}} 頁）",
    "admin.actions.platformNews": "平台消息",
    "admin.actions.platformNewsDesc": "管理瀏覽頁面上的消息項目",
    "admin.news.activate": "發布 {{title}}",
    "admin.news.activated": "消息項目已發布",
    "admin.news.activeLabel": "已發布（公開可見）",
    "admin.news.categoryLabel": "類別",
    "admin.news.contentLabel": "內容／摘要",
    "admin.news.contentPlaceholder": "消息項目的簡短描述...",
    "admin.news.createNews": "建立消息項目",
    "admin.news.createNewsBtn": "建立消息",
    "admin.news.created": "消息項目已建立",
    "admin.news.dateLabel": "發布日期",
    "admin.news.deactivate": "隱藏 {{title}}",
    "admin.news.deactivated": "消息項目已隱藏",
    "admin.news.deleteItem": "刪除 {{title}}",
    "admin.news.deleted": "消息項目已刪除",
    "admin.news.editItem": "編輯 {{title}}",
    "admin.news.editNews": "編輯消息項目",
    "admin.news.imageLabel": "圖片網址（選填）",
    "admin.news.imagePlaceholder": "https://...",
    "admin.news.inactive": "未啟用",
    "admin.news.newItem": "新增項目",
    "admin.news.noItemsMessage": "建立您的第一則消息項目，與社群分享最新動態",
    "admin.news.noItemsYet": "尚無消息項目",
    "admin.news.publishedOn": "發布於 {{date}}",
    "admin.news.saving": "儲存中...",
    "admin.news.subtitle": "管理公開瀏覽頁面上顯示的消息項目",
    "admin.news.title": "平台消息",
    "admin.news.titleLabel": "標題",
    "admin.news.titlePlaceholder": "例如：季度影響力報告",
    "admin.news.updateNews": "更新消息",
    "admin.news.updated": "消息項目已更新",
    "admin.news.urlLabel": "連結網址",
    "admin.news.urlPlaceholder": "https://example.org/article",
    "charity.walletBadge.institutionalLabel": "存放於 {{custodianName}}",
    "charity.walletBadge.institutionalTooltip":
      "捐款將存入由合格機構託管人持有的錢包。",
    "charity.walletBadge.safeLabel":
      "多重簽署國庫 · {{threshold}}-of-{{count}} 簽署人",
    "charity.walletBadge.safeTooltip":
      "捐款將存入需要多方核准才能動用資金的多重簽署錢包。",
    "wallet.eoa.chain": "網路",
    "wallet.eoa.checkAuthorized":
      "我已獲得所屬組織授權，可將此錢包指定為慈善捐款的收款地址。",
    "wallet.eoa.checkRisk":
      "我瞭解單一簽署錢包的風險高於多重簽署錢包，且私鑰遺失即代表資金永久遺失。",
    "wallet.eoa.confirmSubtitle": "在註冊此錢包之前，請先確認以下事項。",
    "wallet.eoa.confirmTitle": "最終確認",
    "wallet.eoa.connectFirst": "請先連接您的錢包。",
    "wallet.eoa.connectWallet": "連接錢包",
    "wallet.eoa.missingSignature": "缺少簽名。請返回並重新簽署。",
    "wallet.eoa.proceedAnyway": "我瞭解，繼續進行",
    "wallet.eoa.register": "註冊錢包",
    "wallet.eoa.registering": "註冊中...",
    "wallet.eoa.rejected": "簽名請求已被拒絕。",
    "wallet.eoa.riskParagraph1":
      "單一簽署（EOA）錢包由單一私鑰控制。若該私鑰遺失、被竊或遭到入侵，發送至此錢包的所有資金將永久無法尋回。",
    "wallet.eoa.riskParagraph2":
      "對於組織資金，我們強烈建議改用多重簽署 Safe 錢包。多重簽署錢包要求每筆交易都經過多方核准，可防止單點故障。",
    "wallet.eoa.riskParagraph3":
      "繼續操作即表示您確認，Give Protocol 對因私鑰遭入侵、遺失或管理不當而造成的任何資金損失概不負責。",
    "wallet.eoa.riskTitle": "單一簽署錢包：重要風險提示",
    "wallet.eoa.signError": "簽署訊息失敗。請再試一次。",
    "wallet.eoa.signMessage": "簽署驗證訊息",
    "wallet.eoa.signSubtitle":
      "連接您的錢包並簽署訊息，以證明您擁有此地址的控制權。",
    "wallet.eoa.signTitle": "連接並簽署",
    "wallet.eoa.useMultisig": "改用多重簽署錢包",
    "wallet.eoa.walletConnection": "錢包",
    "wallet.eoa.walletToRegister": "待註冊錢包",
    "wallet.institutional.address": "錢包地址",
    "wallet.institutional.attestation": "證明文件",
    "wallet.institutional.attestationHelp":
      "請上傳 PDF、JPEG 或 PNG 檔案（上限 10MB），以證明您的託管關係。",
    "wallet.institutional.backToWallets": "返回錢包清單",
    "wallet.institutional.chain": "網路",
    "wallet.institutional.chooseFile": "選擇檔案或拖曳至此",
    "wallet.institutional.custodian": "託管人",
    "wallet.institutional.fileTooLarge": "檔案大小須小於 10MB。",
    "wallet.institutional.invalidAddress":
      "請輸入有效的 Ethereum 地址（0x...）",
    "wallet.institutional.invalidFileType": "請上傳 PDF、JPEG 或 PNG 檔案。",
    "wallet.institutional.removeFile": "移除檔案",
    "wallet.institutional.selectCustodian": "請選擇託管人。",
    "wallet.institutional.selectCustodianOption": "選擇託管人...",
    "wallet.institutional.submit": "提交審核",
    "wallet.institutional.submittedDesc":
      "您的機構託管錢包註冊申請正在審核中。您將於 3 個工作天內收到電子郵件通知。",
    "wallet.institutional.submittedTitle": "錢包已提交審核",
    "wallet.institutional.submitting": "提交中...",
    "wallet.institutional.subtitle":
      "請提供您託管人管理的錢包詳細資料，並上傳證明文件以供驗證。",
    "wallet.institutional.title": "註冊機構託管錢包",
    "wallet.institutional.uploadFile": "上傳證明文件",
    "wallet.institutional.uploadRequired": "請上傳證明文件。",
    "wallet.safe.address": "Safe 地址",
    "wallet.safe.chain": "網路",
    "wallet.safe.connectFirst": "請先連接您的簽署錢包。",
    "wallet.safe.connectSigner": "連接簽署錢包",
    "wallet.safe.createNew": "建立新的 Safe",
    "wallet.safe.createNewDesc":
      "開啟 app.safe.global，您可以在此建立新的多重簽署錢包。部署完成後請返回此處。",
    "wallet.safe.haveOne": "我已經有 Safe",
    "wallet.safe.haveOneDesc":
      "輸入您的 Safe 地址，並透過簽署錢包簽署訊息以驗證控制權。",
    "wallet.safe.invalidAddress": "請輸入有效的 Ethereum 地址（0x...）",
    "wallet.safe.rejected": "簽名請求已被拒絕。",
    "wallet.safe.signError": "驗證訊息簽署失敗。請再試一次。",
    "wallet.safe.signVerify": "簽署以驗證",
    "wallet.safe.signerWallet": "簽署錢包",
    "wallet.safe.subtitle":
      "Safe 需要多方簽署人核准每筆交易，為您慈善機構的資金提供最高等級的安全保障。",
    "wallet.safe.title": "設定 Safe 多重簽署錢包",
    "wallet.safe.verifyTitle": "驗證 Safe 所有權",
    "wallet.safe.verifying": "驗證中...",
    "wallet.setup.addAnother": "新增另一個",
    "wallet.setup.custodian": "託管人",
    "wallet.setup.deleteFailed": "移除錢包失敗",
    "wallet.setup.eoaDesc":
      "由單一私鑰控制的標準錢包。最簡單但對組織用途而言安全性最低。",
    "wallet.setup.eoaTitle": "單一簽署（EOA）",
    "wallet.setup.institutionalDesc":
      "由合格託管人（Fireblocks、Anchorage 等）管理。需要提交證明文件。",
    "wallet.setup.institutionalTitle": "機構託管",
    "wallet.setup.makePrimary": "設為主要錢包",
    "wallet.setup.primary": "主要",
    "wallet.setup.primaryFailed": "更新主要錢包失敗",
    "wallet.setup.primaryUpdated": "主要錢包已更新",
    "wallet.setup.recommended": "建議使用",
    "wallet.setup.remove": "移除錢包",
    "wallet.setup.safeDesc":
      "每筆交易皆須多方簽署人核准。為組織資金提供最高安全性。",
    "wallet.setup.safeSigners": "簽署人",
    "wallet.setup.safeTitle": "多重簽署 Safe",
    "wallet.setup.subtitle":
      "選擇您的慈善機構接收加密貨幣捐款的方式。我們建議使用多重簽署錢包以確保最高安全性。",
    "wallet.setup.title": "設定您的收款錢包",
    "wallet.setup.viewExplorer": "在區塊瀏覽器中檢視",
    "wallet.setup.walletAdded": "錢包註冊成功",
    "wallet.setup.walletDeleted": "錢包已移除",
    "wallet.setup.walletsTitle": "收款錢包",
    "admin.nav.dashboard": "儀表板",
    "admin.nav.reports": "報告與分析",
    "admin.nav.charities": "慈善機構",
    "admin.nav.donations": "捐款",
    "admin.nav.impactMetrics": "影響力指標",
    "admin.nav.portfolioFunds": "投資組合基金",
    "admin.nav.contentModeration": "內容審核",
    "admin.nav.settings": "系統設定",
    "admin.nav.overview": "總覽",
    "admin.nav.operations": "營運",
    "admin.nav.consoleLabel": "管理主控台",
    "admin.shell.searchPlaceholder": "搜尋捐款者、慈善機構、交易雜湊…",
    "admin.shell.searchLabel": "搜尋管理主控台",
    "admin.shell.notifications": "通知",
    "admin.shell.adminLabel": "管理員",
    "admin.shell.superAdmin": "超級管理員",
    "admin.shell.signOut": "登出",
    "admin.shell.backToPublicSite": "返回公開網站",
    "admin.shell.homeLink": "Give Protocol 首頁",
    "admin.dashboard.severityHigh": "高優先",
    "admin.dashboard.severityMedium": "需要留意",
    "admin.dashboard.severityLow": "待審查",
    "admin.dashboard.alertOldest": "最早提交的申請",
    "admin.dashboard.alertReviewHint": "審查以維持審核流程順暢進行",
    "admin.dashboard.reviewQueue": "審查佇列",
    "admin.dashboard.kpiDonorsSub": "過去 30 天新增 {{count}} 位",
    "admin.dashboard.kpiPending": "{{count}} 筆待處理",
    "admin.dashboard.awaitingVerification": "等待驗證",
    "admin.dashboard.kpiVerifiedSub": "佔已核准總數 {{total}} 筆",
    "admin.dashboard.kpiVolunteersActive": "有效報名人數",
    "admin.dashboard.kpiVolunteersSub": "目前無有效報名",
    "admin.dashboard.donationVolume": "捐款量",
    "admin.dashboard.donationVolumeSub": "{{range}} · 加密貨幣與法幣合計",
    "admin.dashboard.range30d": "過去 30 天",
    "admin.dashboard.range90d": "過去 90 天",
    "admin.dashboard.rangeYtd": "本年迄今",
    "admin.dashboard.volumeEmptyTitle": "尚無捐款記錄",
    "admin.dashboard.volumeEmptySub": "首筆捐款結算後將於此顯示趨勢圖",
    "admin.dashboard.totalVolume": "總量",
    "admin.dashboard.crypto": "加密貨幣",
    "admin.dashboard.fiat": "法幣",
    "admin.dashboard.activitySubtitle": "平台事件即時動態",
    "admin.dashboard.viewAllActivity": "檢視所有活動",
    "admin.dashboard.viewAllDonations": "檢視所有捐款",
    "admin.charity.tabAll": "全部",
    "admin.charity.review": "審查",
    "admin.charity.colOrganization": "組織",
    "admin.charity.colRaised": "已募得",
    "admin.charity.colSubmitted": "提交時間",
    "admin.charity.searchAria": "搜尋慈善機構",
    "admin.charity.reviewTitle": "審查 {{name}}",
    "admin.charity.submittedRelative": "提交於 {{when}}",
    "admin.charity.contactEmail": "電子郵件",
    "admin.charity.contactPhone": "電話",
    "admin.charity.raisedUnavailable": "無可用捐款總額",
    "admin.error.title": "資料載入錯誤",
    "admin.error.recentActivity": "近期活動載入錯誤",
    "admin.error.alerts": "警示載入錯誤",
    "admin.error.donationVolume": "捐款量載入錯誤",
    "donation.gas.estimating": "正在估算網路手續費…",
    "donation.gas.label": "預估網路手續費",
    "donation.gas.highGasWarning":
      "高手續費警示：預估手續費為 {{usd}}，佔您捐款金額的 {{pct}}。",
    "donation.gas.highGasSuggestion":
      "建議提高捐款金額，或改用手續費較低的鏈。",
    "donation.gas.l2Hint": "若想降低手續費，可嘗試 {{chains}}。",
  },
};
